// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class ResourceLockTMO {
	public holderId?: string = undefined;
	public resourceType?: ResourceLockTypeEnum = undefined;
	public resourceId?: string = undefined;
	public createdDate?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class ResourceLock extends ResourceLockTMO {
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************

// ENUMS #############################################################
// API enums *********************************************************
export enum ResourceLockTypeEnum {
	BUSINESS_PREMISES = 'businessPremises'
}

// UI enums *********************************************************
